<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <div style="width:100%; padding-top:10px; padding-bottom:10px" class="grey lighten-4">
            <table :class="'font-weight-regular; '+($vuetify.breakpoint.xs ? 'caption' : '')">
                <tr>
                    <td>■</td>
                    <td style="width:100%">あなたの情報を登録します。</td>
                    <!-- <td rowspan="2">
                        <v-btn @click="onClickSave" color="primary" class="mr-2">保存</v-btn>
                    </td> -->
                </tr>
                <tr>
                    <td></td>
                    <td class="font-weight-bold">※入力後は、必ず保存ボタンを押して下さい。</td>
                </tr>
            </table>
        </div>
        <v-container fluid>
            <v-row>
                <v-btn @click="onClickSave" color="primary" block>保存</v-btn>
            </v-row>
        </v-container>
        <v-form ref="form">
            <v-container fluid class="pa-0">
                <v-row align="end">
                    <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                        <v-card :width=200 outlined v-if="editImage != null ">
                            <v-layout justify-center style="margin-top:10px">
                                <v-img v-if="editImage.state == 2 || (editImage.url == '' && editImage.image == '')" src="@/assets/no_avater_image.png" :max-width=180 :max-height=180 contain alt="No image" />
                                <v-img v-if="editImage.state != 2 && editImage.url != '' && editImage.image == ''" :src="editImage.url" :max-width=180 :max-height=180 contain />
                                <v-img v-if="editImage.state != 2 && editImage.image != ''" :src="editImage.image" :max-width=180 :max-height=180 contain />
                            </v-layout>
                            <v-card-actions>
                                <v-btn v-if="editImage.state == 1 || editImage.url != ''" icon color="primary" @click="onClickDeleteImage" ><v-icon large>mdi-delete</v-icon></v-btn>
                                <v-spacer />
                                <ImageImporter @onImportedImage="onImportedImage" />
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8">
                        <v-container fluid class="pa-0">
                            <v-row dense>
                                <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                                    <v-text-field 
                                        v-model="editValues.userName" 
                                        clearable 
                                        label="名前"
                                        outlined
                                        dense 
                                        type="text" 
                                        persistent-hint
                                        hint="あなたの名前を入力します。(必須)" 
                                        counter="20"
                                        :rules="[validatorRequire, validatorNameLength]" />
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                                    <v-select 
                                        dense 
                                        v-model="editValues.publicSetting" 
                                        label="公開設定" 
                                        outlined 
                                        :items="publicSettingTypes" 
                                        item-text="text" 
                                        item-value="value" 
                                        :hint="publicSettingContent" 
                                        persistent-hint
                                        />
                                </v-col>
                                <v-col cols="12">
                                    <v-btn color="cyan white--text" @click="onClickPassword">パスワード変更</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <!-- vuetifyのv-checkboxはクソなのか？ -->
                        <v-checkbox
                            v-model="editValues.notification.enabled"
                            label="通知受信時にメールで知らせる" />
                        <v-text-field
                            v-if="editValues.notification.enabled"
                            class="ml-2"
                            v-model="editValues.notification.email"
                            dense                                
                            clearable 
                            label="通知先のメールアドレス"
                            outlined 
                            type="text"
                            :rules="[validatorRequire, validatorEMail]" />
                    </v-col>
                </v-row>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header >住所</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <Address v-if="editValues != null" v-model="editValues.address" />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-container>
        </v-form>
        <PasswordChange ref="passwordChanger" />
        <Confirm ref="confirm" />
        <v-snackbar v-model="notification.isView" :timeout=2000 :color="notification.color">{{notification.message}}</v-snackbar>
    </v-container>
</template>

<script>
    import Confirm from '@/components/tools/ConfirmDialog';
    import ImageImporter from '@/components/tools/ImageImporter';
    import Address from '@/components/tools/AddressSetter';
    import PasswordChange from '@/components/setting/items/ChangeUserPassword';
    import db from '@/firebase/firestore.js'
    import fb from '@/firebase/firebase.js'
    export default {
        components: {
            Confirm,
            ImageImporter,
            Address,
            PasswordChange
        },
        computed: {
            publicSettingTypes: function () {
                return this.$store.getters["publicSettingTypes"]
            },
            publicSettingContent: function () {
                return this.publicSettingTypes[this.publicSettingTypes.findIndex((v) => v.value == this.editValues.publicSetting)].content
            },
            areas: function () {
                return this.$store.getters["areas"]
            }
        },
        data: function () {
            return {
                notification: {
                    isView: false,
                    message: "",
                    color: "primary"
                },
                maskPostal: "###-####",
                isNewUser: false,
                editValues: {
                    version: "1.0.0",
                    userUID: this.$store.getters["userUID"],
                    userID: "",
                    userName: this.$store.getters["firebaseUser"].displayName,
                    address: {
                        postalCode: "",
                        pref: "",
                        city: "",
                        address1: "",
                        address2: "",
                        areaID: ""
                    },
                    notification: {
                        enabled: false,     
                        email: ""
                    },
                    avaterImage: null,
                    publicSetting: 0,
                    isSystemManager: false,
                    systemNotification: {
                        lastDateTime: ""
                    },
                    referenceUserInfo: {
                        group: {
                            ownerUserUID: null,
                            groupNo: 0
                        },
                        userUID: null
                    },
                    license: {
                        code: null,
                        dateTime: null,
                        isLicenseManager: false
                    },
                    systemVersion: this.$store.getters["systemVersion"],
                    registeredDateTime: "",
                    updatedDateTime: ""
                },
                editImage: null,
                sharedUsers: [],
                validatorRequire: value => !!value || '必須入力です。',
                validatorIDLengthMin: value => value.length >= 8 || '8～12文字の範囲で入力して下さい。',
                validatorIDLengthMax: value => value.length <= 12 || '8～12文字の範囲で入力して下さい。',
                validatorIDCharPattern: value => /^[a-zA-Z0-9._-]+$/.test(value) || 'IDには英数字と._-が使用出来ます。',
                validatorNameLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
                validatorAddressLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
                validatorEMail: value => /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value) || 'アドレスをチェックして下さい。'
            }
        },
        created: function () {
            const self = this

            var user = this.$store.getters["userData"]

            if (user == null) {
                this.editValues.userUID = this.$store.getters["userUID"]
                this.editValues.userName = this.$store.getters["firebaseUser"].displayName
                this.isNewUser = true
            } else {
                this.editValues.version = user.version
                this.editValues.userUID = user.userUID
                this.editValues.userID = user.userID
                this.editValues.userName = user.userName                    
                this.editValues.address.postalCode = user.address.postalCode,
                this.editValues.address.pref = user.address.pref,
                this.editValues.address.city = user.address.city,
                this.editValues.address.address1 = user.address.address1,
                this.editValues.address.address2 = user.address.address2,
                this.editValues.address.areaID = user.address.areaID
                this.editValues.avaterImage = user.avaterImage,
                this.editValues.publicSetting = user.publicSetting,
                this.editValues.isSystemManager = user.isSystemManager,
                this.editValues.systemNotification.lastDateTime = user.systemNotification.lastDateTime
                this.editValues.registeredDateTime = user.registeredDateTime,
                this.editValues.updatedDateTime = user.updatedDateTime
                if (user.notification != null) {
                    this.editValues.notification.enabled = user.notification.enabled
                    this.editValues.notification.email = user.notification.email
                }
                if (user.license != null) {
                    this.editValues.license.code = user.license.code
                    this.editValues.license.dateTime = user.license.dateTime
                    this.editValues.license.isLicenseManager = user.license.isLicenseManager
                }
                this.editValues.systemVersion = user.systemVersion
                this.isNewUser = false
            }
            if (this.editValues.avaterImage != null) {
                this.editImage = {
                    url: this.editValues.avaterImage.url,
                    image: "",
                    capturedDate: this.editValues.avaterImage.capturedDate,
                    state: 0    // 0:未変更,1:変更,2:削除
                }
            } else {
                this.editImage = {
                    url: "",
                    image: "",
                    capturedDate: "",
                    state: 0    // 0:未変更,1:変更,2:削除
                }
            }
            // this.refreshSharedUsers()
        },
        methods: {
            onClickPassword: function () {
                this.$refs.passwordChanger.show()
            },
            onImportedImage: function (image) {
                this.editImage.image = image
                this.editImage.state = 1
                this.editImage.capturedDate = this.df_currentDateTime()
            },
            onClickDeleteImage: function () {
                this.editImage.url = ""
                this.editImage.image = ""
                this.editImage.state = 2                    
            },
            onClickSave: function () {
                if (!this.$refs.form.validate()) {
                    return
                }
                
                if (this.editValues.address.areaID == undefined) {
                    this.editValues.address.areaID = null
                }

                this.$store.commit("processing", {start:true, message:"登録中です。"})

                const self = this
                const userUID = this.$store.getters["userUID"]
                
                var register = function () {

                    var userRegister = function () {
                        self.$store.commit("updateUserData", {
                            userUID: self.$store.getters["userUID"],
                            userData: self.editValues,
                            success: function () {
                                self.$store.commit("processing", {start:false})
                                self.$store.commit("userData", self.editValues)
                                self.showNotification("ユーザー情報を登録しました。")
                            },
                            failed: function (error) {
                                console.log("User", "onClickSave", "update user data failed!!", error)
                                self.$store.commit("processing", {start:false})
                                self.showNotification("ユーザー情報の登録に失敗しました。", true)
                            }
                        })
                    }

                    // アバターから処理
                    const uploadUrl = "images/users/" + userUID + "/avater"
                    var storage = fb.storage().ref()
                    var outputRef = storage.child(uploadUrl)

                    switch (self.editImage.state) {
                        case 1: // 変更
                            // ===============================
                            // 画像のアップロード
                            const startIndex = self.editImage.image.indexOf(",") + 1
                            outputRef.putString(self.editImage.image.substring(startIndex), 'base64').then(function(snapShot){
                                snapShot.ref.getDownloadURL().then (function(url){
                                    self.editValues.avaterImage = {
                                        version: "1.0.0",
                                        url: url,
                                        capturedDate: self.editImage.capturedDate
                                    }
                                    // =======================================
                                    // 画像の処理が終了で、ユーザー情報更新
                                    userRegister()
                                })
                            })
                            break;
                        case 2:
                            if (self.editImage.url != "") {
                                outputRef.delete().then(function (){
                                    self.editValues.avaterImage = null
                                    userRegister()
                                })
                            }
                            break;
                        case 0:
                            userRegister()
                            break;
                    }
                }
                register()
            },
            showNotification: function (message, isError){
                this.notification.message = message
                if (isError) {
                    this.notification.color = "error"
                } else {
                    this.notification.color = "primary"
                }
                this.notification.isView = true
            }
        }
    }
</script>